import { useEffect } from 'react';

export default function useSmoothScroll() {
  useEffect(() => {
    // Native document scrolling is more reliable for nested admin panels,
    // dialogs, touch devices, embeds and accessibility tools. Remove stale
    // Lenis classes that can survive hot reloads and leave the page locked.
    const root = document.documentElement;
    const body = document.body;
    const staleClasses = ['lenis', 'lenis-smooth', 'lenis-scrolling', 'lenis-stopped'];
    staleClasses.forEach((className) => {
      root.classList.remove(className);
      body.classList.remove(className);
    });
    if (root.style.overflow === 'hidden') root.style.removeProperty('overflow');
    if (body.style.overflow === 'hidden') body.style.removeProperty('overflow');

    return () => {
      staleClasses.forEach((className) => {
        root.classList.remove(className);
        body.classList.remove(className);
      });
    };
  }, []);
}
